import { PopoverTrigger as Trigger } from '@components/ui/popover'
import type React from 'react'

export default function PopoverTrigger({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return <Trigger asChild>{children}</Trigger>
}
